import { render, staticRenderFns } from "./TravelContainer.vue?vue&type=template&id=6748ccf9"
import script from "./TravelContainer.vue?vue&type=script&lang=ts"
export * from "./TravelContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports